<div [ngClass]="{ 'bfx-app-header': true, noselect: true }" nativeDesktopClass="desktop">
  <bfx-dashboard-menu></bfx-dashboard-menu>

  <!-- 
    <img fxFlex="0 0 auto" class="bfx-logo" alt="Barracuda FX" />
  <img fxFlex="0 0 auto" fxHide.xs class="bfx-install-logo" /> 
-->
  <!-- 
    <bfx-nucleus-svg></bfx-nucleus-svg>
  <bfx-title-svg></bfx-title-svg> 
-->
  <div class="bfx-logo-container">
    <bfx-logo-svg></bfx-logo-svg>
  </div>
  <div fxFlex="1 1 auto" fxLayoutAlign="center center" class="helper">
    <div fxFlex="1 1 auto" class="helper" nativeDesktopClass="dragger"></div>
    <div fxFlex="0 0 auto" fxHide.xs class="frame-tag" nativeDesktopClass="dragger">
      {{ frameTag }}
    </div>
    <div fxFlex="1 1 auto" class="helper" nativeDesktopClass="dragger"></div>
  </div>

  <bfx-neworder-menu></bfx-neworder-menu>
  <bfx-notifications-bar></bfx-notifications-bar>
  <bfx-user-menu></bfx-user-menu>
  <div fxFlex="0 0 auto" fxLayoutAlign="right center" *ngIf="shouldMaximizeMinimize">
    <bfx-icon-button
      size="md"
      *ngIf="devMode"
      iconClass="icon-bug_report"
      (action)="openDevTools()"
      title="Open Dev tools"
    ></bfx-icon-button>
    <bfx-icon-button
      size="md"
      iconClass="icon-remove"
      (action)="minimize()"
      title="Minimize"
    ></bfx-icon-button>
    <bfx-icon-button
      size="md"
      [iconClass]="maximized ? 'icon-bfx_pop_out' : 'icon-bfx_square'"
      (action)="maximize()"
      [title]="maximized ? 'Restore' : 'Maximize'"
    ></bfx-icon-button>
    <bfx-icon-button
      size="md"
      iconClass="icon-close"
      (action)="close()"
      title="Close"
    ></bfx-icon-button>
  </div>
</div>
